import styled, { css } from 'styled-components';

import { Box, type BoxProps } from '@yoweb/ui/components/Box';
import { getColor } from '@yoweb/ui/styles/utils/theme';

export const Card = styled(
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  ({ withMobileBorder = true, ...rest }: BoxProps & { withMobileBorder?: boolean }) => (
    <Box {...rest} />
  ),
)`
  ${({ withMobileBorder }) =>
    withMobileBorder &&
    css`
      border: 1px solid ${getColor('base050')};
    `}
`;

Card.defaultProps = {
  p: { _: 'normal2', md: 'normal4' },
  radii: 'medium',
  backgroundColor: 'base000',
};
export default Card;
